/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import {FormattedMessage, useIntl} from 'react-intl';

import {BasketIcon, BrandLogo} from '@salesforce/retail-react-app/app/components/icons';
import Link from '@salesforce/retail-react-app/app/components/link';
import {Badge, Box, Button, Center, Flex} from '@salesforce/retail-react-app/app/components/shared/ui';
import {HOME_HREF} from '@salesforce/retail-react-app/app/constants';
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket';

const CheckoutHeader = () => {
  const intl = useIntl();
  const {
    derivedData: {totalItems},
  } = useCurrentBasket();

  return (
    <Box bg="white" borderBottom="1px" borderColor="gray.100" px={[4, 4, 8]}>
      <Box marginLeft="auto" marginRight="auto" maxWidth="container.xxxl">
        <Flex align="center" h={{base: '52px', md: '80px'}} justify="space-between">
          <Link href={HOME_HREF} title="Back to homepage">
            <BrandLogo
              height={{base: '24px', md: '32px'}}
              width={{base: '35px', md: '45px'}}
            />
          </Link>

          <Button
            as={Link}
            color="gray.900"
            display="inline-flex"
            href="/cart"
            variant="unstyled"
            aria-label={intl.formatMessage(
              {
                id: 'checkout_header.link.assistive_msg.cart',
                defaultMessage: 'Back to cart, number of items: {numItems}',
              },
              {numItems: totalItems}
            )}
            rightIcon={
              <Center height={11} position="relative" width={11}>
                <BasketIcon left="0px" position="absolute" />
                <Badge variant="notification">{totalItems}</Badge>
              </Center>
            }
          >
            <FormattedMessage
              defaultMessage="Back to cart"
              id="checkout_header.link.cart"
            />
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};

export default CheckoutHeader;
